
    import { initTutorial } from "./js/tutorial.js";

    document.addEventListener("DOMContentLoaded", () => {
      initTutorial();

      document.getElementById("reopenOnboarding")?.addEventListener("click", () => {
        localStorage.removeItem("inpinity_onboarding_done_v1");
        location.reload();
      });
      document.getElementById("quickShowTutorial")?.addEventListener("click", () => {
        localStorage.removeItem("inpinity_onboarding_done_v1");
        location.reload();
      });
    });
  